/* eslint-disable no-underscore-dangle */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/style-prop-object */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/no-array-index-key */
import { useDispatch } from 'react-redux';

import { setModal } from 'modules/_shared/redux/modalActions';

import Page from 'modules/_shared/components/Pages/Page';
import GoBackButton from 'modules/_shared/components/Buttons/GoBackButton';
import CustomLoading from 'modules/_shared/components/CustomLoading';
import PageListHeader from 'modules/_shared/components/Headers/PageListHeader';
import ToggleWidthButton from 'modules/_shared/components/Buttons/ToggleWidthButton';
import OperationMenuDots from 'modules/_shared/components/MenuDots/OperationMenuDots';
import EmptyStateCard from 'modules/_shared/components/EmptyStates/EmptyStateCard';
import { useGetPartnersSectionPermissions } from 'modules/partners/hooks/useGetPartnerSectionsPermissions';
import { useGetOperationsMenu } from 'modules/transactions/hooks/useGetOperationsMenu';

import { useTranslate } from 'hooks/useTranslate';
import { usePartnerBook } from './hooks/usePartnerBook';

import views from './constants/views';
import './PartnerBook.scss';
import TableToExcelButtons from './components/TableToExcelButtons';
import { usePartnerBookViews } from './hooks/usePartnerBookViews';

function PartnerBook({
  updatedPartners,
  summaryRow,
  draftView,
  convertibleNoteView,
  capitalizedNote,
  buySellDraft,
}) {
  const { t } = useTranslate();
  const dispatch = useDispatch();

  const { isAdmin, isReadOnly } = useGetPartnersSectionPermissions().data;

  const {
    data: {
      actualSociety,
      partnerBook,
      partners,
      // operations,
      plans,
      holdingClasses,
      partnersRegister,
      // holdingClassNames,
      bookDates,
      bookColumns,
      bookHeaders,
      bookComments,
      bookPartners,
      bookOperations,
      bookTotals,
      bookTotalPartners,
      bookOrder,
      bookDocuments,
      view,
      // currentMenuOptions,
      currentViewOptions,
      isPartnerBookVisible,
      user,
    },
    actions: {
      setView,
      handleExportTable,
      // handleExportEquityStory,
    },
    isLoading,
    isLoadingPartnersRegister,
  } = usePartnerBook({
    updatedPartners,
    summaryRow,
    draftView,
    convertibleNoteView,
    capitalizedNote,
    buySellDraft,
    isAdmin,
    isReadOnly,
  });

  const { data: filtredMenuOptions } = useGetOperationsMenu();

  const {
    data: {
      renderPartnerBookTable,
      renderCommercialRegisterTable,
      renderClassesTable,
      renderClassesTableInversionTable,
      renderClassesTableInvestorsTable,
    },
  } = usePartnerBookViews({
    view,
    draftView,
    convertibleNoteView,
    capitalizedNote,
    bookData: {
      bookDates,
      bookColumns,
      bookHeaders,
      bookComments,
      bookPartners,
      bookOperations,
      bookTotals,
      bookTotalPartners,
      bookOrder,
      bookDocuments,
    },
    partners,
    partnerBook,
    partnersRegister,
    updatedPartners,
    plans,
    holdingClasses,
  });

  return (
    <Page id="partner-book">
      <PageListHeader
        title={actualSociety?.name}
        subTitle={t('PartnerBook')}
        actions={[
          <GoBackButton
            className={
              !draftView ? 'btn btn-white btn-outline-light' : 'd-none'
            }
          />,

          isPartnerBookVisible && !draftView ? (
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleExportTable}
            >
              {`${t('Download')} ${t('Table')}`}
            </button>
          ) : null,

          isPartnerBookVisible ? (
            <OperationMenuDots
              title={t('View')}
              menuOptions={currentViewOptions}
              params={{
                view,
                setView,
                outlined: true,
              }}
            />
          ) : null,

          isPartnerBookVisible && !draftView ? (
            <OperationMenuDots
              menuOptions={filtredMenuOptions}
              handleModal={(Modal) =>
                dispatch(
                  setModal(
                    <Modal user={user} societyId={actualSociety['_id']} />
                  )
                )
              }
              disabled={isReadOnly}
              params={{
                society: actualSociety,
                user: user['_id'],
              }}
            />
          ) : null,

          !draftView ? <ToggleWidthButton /> : null,
        ].filter(Boolean)}
      />

      <TableToExcelButtons
        actualSociety={actualSociety}
        isPartnerBookVisible={isPartnerBookVisible}
      />

      <div className="nk-block mb-4">
        {isPartnerBookVisible ? (
          <>
            {/* PARTNER BOOK */}
            {view === views.EQUITY_STORY && renderPartnerBookTable()}

            {/* COMMERCIAL REGISTER */}
            {view === views.COMMERCIAL_REGISTER &&
              renderCommercialRegisterTable()}

            {/* CLASSES TABLE */}
            {view === views.SUMMARY && renderClassesTable()}

            {/* CLASSES TABLE INVERSION */}
            {view === views.SUMMARY_ACCUMULATED &&
              renderClassesTableInversionTable()}

            {/* CLASSES TABLE INVESTORS */}
            {view === views.SUMMARY_INVESTORS &&
              renderClassesTableInvestorsTable()}
          </>
        ) : (
          <EmptyStateCard
            mainMessage={t('PartnerBookWarningTitle')}
            infoMessage={t('PartnerBookWarningDescription')}
          />
        )}
      </div>

      {(isLoading || isLoadingPartnersRegister) && <CustomLoading />}
    </Page>
  );
}

export default PartnerBook;
